// extracted by mini-css-extract-plugin
export default {"loginForm":"loginForm","error-border":"error-border","login-password":"login-password","ant-input-affix-wrapper":"ant-input-affix-wrapper","ant-input":"ant-input","ant-input-suffix":"ant-input-suffix"};
    if(module.hot) {
      // 1790857679049
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  